import {useCollapsibleSidebarContext} from '@github-ui/layout-primitives/CollapsibleSidebar'
import {Sidebar} from '@github-ui/layout-primitives/Sidebar'
import {useSidebarPageLayoutActions} from '@github-ui/layout-primitives/SidebarPageLayout'
import {ArrowUpRightIcon, type Icon} from '@primer/octicons-react'
import {useActionsAnalytics} from '../hooks/use-actions-analytics'

export type SidebarAnalyticsKey =
  | 'all-workflows'
  | 'caches'
  | 'deployments'
  | 'attestations'
  | 'runners'
  | 'lockfile'
  | 'usage'
  | 'performance'

interface SidebarNavItemProps {
  analyticsKey: SidebarAnalyticsKey
  id?: string
  label: string
  href: string
  icon?: Icon
  isCurrent?: boolean
  softNavigationEnabled?: boolean
  'data-turbo'?: 'false'
  external?: boolean
}

export function SidebarNavItem({
  analyticsKey,
  id,
  label,
  href,
  icon: IconComponent,
  isCurrent = false,
  softNavigationEnabled = false,
  'data-turbo': dataTurbo,
  external = false,
}: SidebarNavItemProps) {
  const track = useActionsAnalytics()
  const {visualIsExpanded} = useCollapsibleSidebarContext()
  const {closeDialog} = useSidebarPageLayoutActions()
  const linkProps = softNavigationEnabled ? {to: href} : {href}
  return (
    <Sidebar.Item
      id={id}
      {...linkProps}
      data-turbo={dataTurbo}
      current={isCurrent}
      leadingVisual={IconComponent ? <IconComponent aria-hidden /> : undefined}
      trailingVisual={external && visualIsExpanded ? <ArrowUpRightIcon aria-hidden /> : undefined}
      onClick={() => {
        track('workflow_sidebar.navigate', `ref_loc:actions_workflow_sidebar;destination:${analyticsKey}`)
        if (softNavigationEnabled) closeDialog()
      }}
    >
      {label}
    </Sidebar.Item>
  )
}

SidebarNavItem.displayName = 'SidebarNavItem'
